module.exports = __webpack_public_path__ + "static/media/S1N9-1.219fdf8b.svg";